import { gql } from '@apollo/client';
import { Box } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { CellProps } from 'react-table';
import { PowerScheduleTable_PowerScheduleFragment } from '../__generated__/PowerScheduleTable.graphql';

export function DescriptionCell({
  value,
}: PropsWithChildren<CellProps<PowerScheduleTable_PowerScheduleFragment, string>>) {
  return (
    <Box overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
      {value}
    </Box>
  );
}

DescriptionCell.graphql = {
  fragments: {
    DescriptionCell_powerSchedule: gql`
      fragment DescriptionCell_powerSchedule on PowerSchedule {
        id
        description
      }
    `,
  },
};
